import { render, staticRenderFns } from "./ProjectHoverCard.vue?vue&type=template&id=49e4bb26"
import script from "./ProjectHoverCard.vue?vue&type=script&lang=ts"
export * from "./ProjectHoverCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('49e4bb26')) {
      api.createRecord('49e4bb26', component.options)
    } else {
      api.reload('49e4bb26', component.options)
    }
    module.hot.accept("./ProjectHoverCard.vue?vue&type=template&id=49e4bb26", function () {
      api.rerender('49e4bb26', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/new/scheduler/ProjectHoverCard.vue"
export default component.exports